import Tool, { type IToolAvailableInput } from './Tool';
import { hasRecordReference, isShapeRecord } from '../objects/guards';
import { importHierarchy } from '../utils/recordImport/hierarchyImport';
import type { HierarchyImportProps } from '../utils/recordImport/HierarchyImportTypes';
class ToolImportHierarchy extends Tool {
  static toolName = 'Import record hierarchy';

  static async action({ controller, selection, relationshipType }) {
    relationshipType ||= 'parents';

    if (!isShapeRecord(selection) || !hasRecordReference(selection)) {
      controller.actionShowMessage({
        type: 'error',
        message: 'Selection must be linked to a supported record type',
      });
      return;
    }

    const props: HierarchyImportProps = {
      controller,
      selection,
      relationshipType,
    };

    await importHierarchy(props);

    Tool.toolActionComplete({ controller });
  }

  static available({ selection, controller }: IToolAvailableInput): boolean {
    return (
      !!selection &&
      isShapeRecord(selection) &&
      hasRecordReference(selection) &&
      Boolean(
        controller.relatedRecordManager?.supportedRecordTypes.includes(
          selection.recordType ?? ''
        )
      )
    );
  }
}

export default ToolImportHierarchy;
